var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Preloader',{ref:"preloader"}),_c('router-view'),_c('FixedAlert',{attrs:{"message":_vm.message,"theme":"messageTheme"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }